import {authService} from '@/services/AuthService'

export const actions = {
    getGlobals: ({commit}) => {
        return new Promise((resolve, reject) => {
            authService
                .app()
                .then(res => {
                    commit('SET_GLOBALS', res)
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}
